__turbopack_context__.v({
  "fieldset": "wN27IW_fieldset",
  "legend": "wN27IW_legend",
});
